module.exports = __webpack_public_path__ + "img/chpc_index_honor10.f6755784.png";